export default __webpack_public_path__ + "static/media/cubes.6ea1f63e292034f07dc43fa375a16d35.svg";